import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from '@/providers/AuthProvider';

export const LanguageSettings = () => {
	const { i18n } = useTranslation();
	const { user } = useAuth();
	
	const changeLanguage = async (lng: string) => {
		// Change the language in i18n
		i18n.changeLanguage(lng);
		
		// Save the preference to Supabase if user is authenticated
		if (user) {
			try {
				// Update the profile with new settings
				const { error } = await supabase
					.from('profiles')
					.update({ language: lng })
					.eq('id', user.id);
				
				if (error) {
					console.error("Error saving language preference:", error);
				}
			} catch (err) {
				console.error("Failed to save language preference:", err);
			}
		}
	};

	return (
		<div className="space-y-2">
			<label className="text-xs font-medium text-white/70 flex items-center">
				<Globe className="h-3.5 w-3.5 mr-1.5" />
				Language
			</label>
			<Select 
				value={i18n.language} 
				onValueChange={changeLanguage}
				onOpenChange={(open) => {
					// Prevent propagation when opening/closing the select
					if (open) {
						setTimeout(() => {
							const content = document.querySelector('.select-content');
							if (content) {
								content.classList.add('select-content');
							}
						}, 0);
					}
				}}
			>
				<SelectTrigger className="h-7 text-xs">
					<SelectValue placeholder="Select language" />
				</SelectTrigger>
				<SelectContent className="select-content bg-background z-50">
					<SelectItem value="en">English</SelectItem>
					<SelectItem value="fr">Français</SelectItem>
					<SelectItem value="nl">Nederlands</SelectItem>
					<SelectItem value="es">Español</SelectItem>
					<SelectItem value="de">Deutsch</SelectItem>
				</SelectContent>
			</Select>
		</div>
	);
};
